var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTablet30(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M23 6c0-1-1-2-1.933-2H8.933C8 4 7 5 7 6v19c0 1 1 2 1.933 2h12.134C22 27 23 26 23 25V6zM10 6h10a1 1 0 0 1 1 1v16H9V7a1 1 0 0 1 1-1zm5 18c.571 0 1 .375 1 1 0 .5-.429 1-1 1-.558 0-1-.5-1-1s.429-1 1-1z",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTIzIDZjMC0xLTEtMi0xLjkzMy0ySDguOTMzQzggNCA3IDUgNyA2djE5YzAgMSAxIDIgMS45MzMgMmgxMi4xMzRDMjIgMjcgMjMgMjYgMjMgMjVWNnpNMTAgNmgxMGExIDEgMCAwIDEgMSAxdjE2SDlWN2ExIDEgMCAwIDEgMS0xem01IDE4Yy41NzEgMCAxIC4zNzUgMSAxIDAgLjUtLjQyOSAxLTEgMS0uNTU4IDAtMS0uNS0xLTFzLjQyOS0xIDEtMXoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export { SvgTablet30 as ReactComponent };